import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import {
  ArrowLeft,
  ChevronDown,
  ChevronUp,
  Info,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Swal from "sweetalert2";
import { api_get, api_post } from "../../../helpers/index";
import Select from "react-select";

const AddTier = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const navigate = useNavigate(); // Initialize navigate hook

  // State for Tier details
  const [tierName, setTierName] = useState("");
  const [description, setDescription] = useState("");
  const [probabilityWithRank, setProbabilityWithRank] = useState(""); // Changed to string
  const [prize, setPrize] = useState(null); // State for Prize
  const [errors, setErrors] = useState({});
  const [prizes, setPrizes] = useState([]); // State to store the list of prizes
  const [totalRanks, setTotalRanks] = useState(0);
  const [tierSequence, setTierSequence] = useState(""); // Add this line for tier sequence

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  // Fetch the list of prizes from the API
  const fetchPrizes = async () => {
    const result = await api_get("spinwheel/prize/list/1");
    if (result.status) {
      const totalPages = result.data.pagination.total_page;
      let allData = result.data.collection;

      for (let page = 2; page <= totalPages; page++) {
        const pageResult = await api_get(`spinwheel/prize/list/${page}`);
        if (pageResult.status) {
          allData = allData.concat(pageResult.data.collection);
        }
      }

      if (allData.length > 0) {
        const prizeOptions = allData.map((item) => ({
          value: item.prize_id,
          label: item.name,
        }));
        setPrizes(prizeOptions);
      }
    }
  };

  // Add function to fetch total ranks
  const fetchTotalRanks = async () => {
    try {
      const result = await api_get("rank/length");
      if (result.status === 1) {
        setTotalRanks(result.data);
      }
    } catch (error) {
      console.error("Error fetching total ranks:", error);
    }
  };

  useEffect(() => {
    fetchPrizes();
    fetchTotalRanks(); // Add this to initial useEffect
  }, []);

  // Validate input fields
  const validateInputs = () => {
    const newErrors = {};
    if (!tierName.trim()) newErrors.tierName = "Tier name is required.";
    if (!description.trim()) newErrors.description = "Description is required.";
    if (description.trim().length > 60) newErrors.description = "Description must not exceed 60 characters.";
    if (!probabilityWithRank.trim()) {
      newErrors.probabilityWithRank = "Probability with Rank % is required.";
    } else {
      const values = probabilityWithRank.split(",").map(v => v.trim());
      
      if (values.length !== totalRanks) {
        newErrors.probabilityWithRank = `Must provide ${totalRanks} comma-separated values (one for each rank)`;
      } else {
        for (let i = 0; i < values.length; i++) {
          const val = parseFloat(values[i]);
          if (isNaN(val) || val < 0 || val > 100) {
            newErrors.probabilityWithRank = `All values must be numbers between 0 and 100. Invalid value at position ${i + 1}`;
            break;
          }
        }
      }
    }
    if (!prize) newErrors.prize = "Prize is required.";
    if (!tierSequence) newErrors.tierSequence = "Tier sequence is required."; // Add this validation
    if (isNaN(tierSequence) || tierSequence < 0) {
      newErrors.tierSequence = "Tier sequence must be a non-negative number.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle saving the Tier
  const handleSaveTier = async () => {
    if (!validateInputs()) {
      return;
    }

    const body = {
      name: tierName,
      description: description,
      prize_id: prize.value,
      probability_with_rank: probabilityWithRank,
      tier_sequence: parseInt(tierSequence),
    };
    try {
      const result = await api_post("spinwheel/tier/create", body);
      if (result.status === 1) {
        // Show success message with SweetAlert2 and navigate to Tier list
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Tier created successfully!",
        }).then(() => {
          navigate(route.tierList);
        });
      } else {
        // Show error message with SweetAlert2
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to create Tier with the provided information: " + result.message,
        });
      }
    } catch (error) {
      console.error("Error creating Tier:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while creating the Tier. Please try again later.",
      });
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New Tier</h4>
              <h6>Create new Tier</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <div className="page-btn">
                <Link to={route.tierList} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  Back to Tier
                </Link>
              </div>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp className="feather-chevron-up" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>
        <form>
          <div className="card">
            <div className="card-body add-prize pb-0">
              <div className="accordion-card-one accordion" id="accordionExample">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-controls="collapseOne"
                    >
                      <div className="addprize-icon">
                        <h5>
                          <Info className="add-info" />
                          <span>Tier Information</span>
                        </h5>
                        <Link to="#">
                          <ChevronDown className="chevron-down-add" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-prize">
                            <label className="form-label">Tier Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={tierName}
                              onChange={(e) => setTierName(e.target.value)}
                            />
                            {errors.tierName && (
                              <div className="text-danger mt-1">{errors.tierName}</div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Prize</label>
                            <Select
                              classNamePrefix="react-select"
                              options={prizes} // Use the fetched prize list
                              placeholder="Choose"
                              value={prize}
                              onChange={(selectedOption) => setPrize(selectedOption)}
                            />
                            {errors.prize && (
                              <div className="text-danger mt-1">{errors.prize}</div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-prize">
                            <label className="form-label">
                              Probability With Rank % ({totalRanks} ranks)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={probabilityWithRank}
                              onChange={(e) => setProbabilityWithRank(e.target.value)}
                              placeholder={`Enter ${totalRanks} values (e.g., 0,0,0,0,0,0,10)`}
                            />
                            {errors.probabilityWithRank && (
                              <div className="text-danger mt-1">{errors.probabilityWithRank}</div>
                            )}
                            <small className="form-text text-muted">
                              Enter {totalRanks} comma-separated values (0-100), one for each rank from left to right
                            </small>
                          </div>
                        </div>

                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-prize">
                            <label className="form-label">Tier Sequence</label>
                            <input
                              type="number"
                              className="form-control"
                              value={tierSequence}
                              onChange={(e) => setTierSequence(e.target.value)}
                            />
                            {errors.tierSequence && (
                              <div className="text-danger mt-1">{errors.tierSequence}</div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="input-blocks summer-description-box transfer mb-3">
                            <label>Description</label>
                            <textarea
                              className="form-control h-100"
                              rows={5}
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                            />
                            <p className="mt-1">Maximum 60 Characters</p>
                            {errors.description && (
                              <div className="text-danger mt-1">{errors.description}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addprize mb-4">
              <button
                type="button"
                className="btn btn-cancel me-2"
                onClick={() => {
                  navigate(route.tierList);
                }}
              >
                Cancel
              </button>
              <button type="button" className="btn btn-submit" onClick={handleSaveTier}>
                Save Tier
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTier;
